<div class="mr-5 p-5 bg-white w-full">
    <form [formGroup]="formDespacho">
        <div class="flex pb-0 items-baseline">
            <mat-form-field class="w-1/2 mr-5">
                <mat-label>Tipo de despacho</mat-label>
                <mat-select formControlName="tipo_despacho">
                    @for (item of catTipoEnvio; track item.id) {
                        <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                    }
                </mat-select>
                @if(formDespacho.controls["tipo_despacho"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            <div class="w-1/2 mr-5 flex items-baseline">    
                <mat-form-field class="flex-grow">
                    <mat-label>Tema</mat-label>
                    <mat-select formControlName="tipo_tema">
                        @for (item of catTemas; track item.id_tema) {
                            @if(item.id_edo_tema != 3 || item.id_tema == this.oAcuerdo.id_tipo_tema || item.id_tema == this.oAcuerdo.id_tema) {
                                <mat-option [value]="item.id_tema">{{item.nombreTema}}</mat-option>
                            }
                        }
                    </mat-select>
                    @if(formDespacho.controls["tipo_tema"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field> 
                <button mat-mini-fab color="primary" class="ml-2" (click)="agregarTema()" [disabled]="formDespacho.controls['tipo_despacho'].value == 0 || deshabilitado"><mat-icon>add</mat-icon></button>
            </div>
        </div>
    </form>
    <form  [formGroup]="formTema">
        @if(nuevoTema) {
            <div class="flex pb-0"><h3>Nuevo Tema</h3></div>
            <div class="flex pb-0">
                <mat-form-field class="!w-full mr-5">
                    <mat-label>Tema</mat-label>
                    <input type="text" matInput formControlName="descripcion_tema" #descripcion_tema>
                    <mat-hint align="end">{{descripcion_tema.value.length}} / 1000</mat-hint>
                    @if(formDespacho.controls["descripcion_tema"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex pb-0 justify-end">
                <button mat-stroked-button (click)="cancelarTema()" class="mr-1">CANCELAR</button>
                <button mat-flat-button color="primary" (click)="guardarTema()" class="mr-5" [disabled]="!formTema.valid">GUARDAR</button>
            </div>
        }
    </form>
</div>